// src/shared/components/BottomSheet/BottomSheetManager.tsx
import useBottomSheetStore from '@/shared/store/UseBottomSheetStore';
import { EarnPointInfoSheet } from '@/widgets/app/bottom/EarnPointInfoSheet';
import { StarPointConsumeContent } from '@/widgets/app/bottom/StarPointConsumeSheet';
import React from 'react';
import BottomSheet from './BottomSheet';
import { RewardSuccessSheet } from '@/widgets/app/bottom/RewardSuccessSheet';
import { SelectEraListSheet } from '@/widgets/app/bottom/SelectEraListSheet';
import PersonInfoModal from '@/widgets/app/bottom/PersonInfoSheet';
import { ExitQuizSheet } from '@/widgets/app/bottom/ExitQuizSheet';
import { RetryQuizSheet } from '@/widgets/app/bottom/RetryQuizSheet';
import { MessageSheet } from '@/widgets/app/bottom/MessageSheet';
import { DeleteMemberSheet } from '@/widgets/app/bottom/DeleteMemberSheet';
import { UpdateNicknameSheet } from '@/widgets/app/bottom/UpdateNicknameSheet';
import { QuizResultSheet } from '@/widgets/app/bottom/QuizResultSheet';

/**
 * 전역 바텀시트 매니저
 * - 모든 바텀시트를 중앙에서 관리
 */
export const BottomSheetManager: React.FC = () => {
  const { type, props, isOpen, closeSheet } = useBottomSheetStore();

  const renderContent = () => {
    switch (type) {
      case 'star-point-consume':
        return (
          <StarPointConsumeContent
            points={props?.points || 0}
            reward={props?.reward || 0}
            onConfirm={() => {
              closeSheet();
              props?.onConfirm?.();
            }}
            onCancel={props?.onCancel || closeSheet}
          />
        );

      case 'message':
        return (
          <MessageSheet
            type={props?.type}
            message={props?.message}
            onCancelTitle={props?.onCancelTitle}
            onConfirmTitle={props?.onConfirmTitle}
            onConfirm={props?.onConfirm}
            onCancel={props?.onCancel || closeSheet}
            messageFontSize={props?.messageFontSize}
          />
        );

      case 'earn-point':
        return (
          <EarnPointInfoSheet
            currentPoints={props?.currentPoints || 0}
            requiredPoints={props?.requiredPoints || 0}
            onConfirm={props?.onConfirm || closeSheet}
            onEarnMore={props?.onEarnMore || closeSheet}
          />
        );

      case 'reward-success':
        return (
          <RewardSuccessSheet
            reward={props?.reward || 0}
            onConfirm={props?.onConfirm || closeSheet}
          />
        );

      case 'select-era-list':
        return (
          <SelectEraListSheet
            eraCategoryList={props?.eraCategoryList}
            selectedEraCategory={props?.selectedEraCategory}
            setSelectedEraCategory={props?.setSelectedEraCategory}
            closeSheet={closeSheet}
          />
        );

      case 'person-info':
        return (
          <PersonInfoModal
            personInfo={props?.personInfo}
            onConfirm={props?.onConfirm || closeSheet}
            onCancel={props?.onCancel || closeSheet}
          />
        );

      case 'exit-quiz':
        return (
          <ExitQuizSheet
            sessionId={props?.sessionId}
            onConfirm={closeSheet}
            onCancel={props?.onCancel || closeSheet}
            closeSheet={closeSheet}
          />
        );

      case 'retry-quiz':
        return (
          <RetryQuizSheet
            onConfirm={props?.onConfirm}
            onCancel={props?.onCancel || closeSheet}
            closeSheet={closeSheet}
          />
        );

      case 'delete-member':
        return <DeleteMemberSheet onCancel={closeSheet} />;

      case 'update-nickname':
        return <UpdateNicknameSheet onCancel={closeSheet} />;

      case 'quiz-result':
        return (
          <QuizResultSheet
            completedData={props?.completedData}
            onConfirm={props?.onConfirm}
            onCancel={props?.onCancel || closeSheet}
            closeSheet={closeSheet}
          />
        );

      default:
        return null;
    }
  };

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={closeSheet}
      title={props?.title}
      showHeader={props?.showHeader}
      styleOptions={props?.styleOptions}
      themeColor={props?.themeColor}
      position={props?.position}
    >
      {renderContent()}
    </BottomSheet>
  );
};
